import { ingredientsQuery } from '@/api/ingredients/ingredientQueries';
import { env } from '@/env';
import { routes } from '@/routes/routes';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useMemo } from 'react';
import { Heading } from '../common/Heading';

interface IngredientCardProps {
  ingredientName: string;
}

export const IngredientCard = ({ ingredientName }: IngredientCardProps) => {
  const { data: ingredientData } = useQuery(ingredientsQuery());

  const ingredients = useMemo(() => {
    return ingredientData?.data[ingredientName];
  }, [ingredientData, ingredientName]);

  return (
    <div>
      <Heading asChild size="h3" className="text-secondary mb-3 text-left">
        <p>{ingredientName}</p>
      </Heading>

      <div className="align-items-start mt-8 grid w-full grid-cols-2 justify-items-center gap-x-8 gap-y-14 lg:w-fit lg:grid-cols-3 xl:grid-cols-4">
        {ingredients?.map((ingredient) => (
          <Link
            key={ingredient.id}
            to={routes.ingredients.ingredient}
            params={{ ingredientId: ingredient.id }}
            className="group w-full max-w-37.5 text-center transition-all duration-300 hover:scale-105 lg:max-w-65"
          >
            <div className="bg-accent mb-6.5 h-37.5 w-full overflow-hidden rounded-full transition-all duration-300 group-hover:shadow-sm lg:h-65">
              <img
                src={env.VITE_API_STORAGE_BASE_URL + ingredient.image_url}
                alt={ingredient.name}
                className="h-full w-full object-cover"
              />
            </div>

            <Heading asChild size="h5" className="text-secondary mb-2.5">
              <p>{ingredient.name}</p>
            </Heading>
            <p>{ingredient.location}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
